import api from './axios';

const getFileSizeConfig = async ({moduleName}) => {
  try {
    const tenantUuid = localStorage.getItem('uuidTenant');
    const { data } = await api.get(`/tenant/${tenantUuid}/config/${moduleName}`);

    return data;
  } catch (error) {
    if (!error.response) {
      throw error;
    }
    throw error.response.data ? error.response.data : error.response;
  }
};

export default {
  getFileSizeConfig,
};
